import http from '../api/axios';

export const getExpertList = (params) => {
    return http.post('/api/expert/lotteryExpertList',params);
}
export const getExpertInfo = (params) => {
    return http.post('/api/expert/expertInfo',params);
}
export const getKillnoInfo = (params) => {
    return http.post('/api/expert/killnoInfo',params);
}
export const getPredictionInfo = (params) => {
    return http.post('/api/expert/predictionInfo',params);
}
export const postAddfollow = (params) => {
    return http.post('/api/expert/addfollow',params);
}
export const postExpertContent = (params) => {
    return http.post('/api/expert/expertDataList',params);
}
export const postExpertConfig = (params) => {
    return http.post('/api/expert/expertConfig',params);
}
export const postExpertAddKillno = (params) => {
    return http.post('/api/expert/addKillno',params);
}
export const postExpertAddPrediction = (params) => {
    return http.post('/api/expert/addPrediction',params);
}
export const postApplyExpert = (params) => {
    return http.post('/api/expert/apply',params);
}



// WEBPACK FOOTER //
// ./src/api/expert.js